import React, {Component} from 'react';
import './countup.scss';
import {connect} from "react-redux";
import {withTranslate} from "react-redux-multilingual";

const FIGURES = [
    {value: '1200', label: 'square_areas'},
    {value: '23', label: 'parking'},
    {value: '56', label: 'apartments'},
    {value: '320', label: 'green_areas'},
];

class CounterBlock extends Component {
    render() {
        const {translate} = this.props;
        return (
            <dl className="cpr-figures">
                {FIGURES.map(figure => (
                    <div className="cpr-figures__item" key={figure.label}>
                        <dt className="cpr-figures__label">{translate(figure.label)}</dt>
                        <dd className="cpr-figures__value cpr-num">{figure.value}</dd>
                    </div>
                ))}
            </dl>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        locale: state.Intl.locale
    }
};

export default connect(mapStateToProps)(withTranslate(CounterBlock));
